module.exports = __webpack_public_path__ + "img/small-16.b738c46e.webp";